import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Loader, PageContext, useApi } from '@axiom/ui';

import { WindowUtil } from '../../utils/WindowUtil';
import { AuthApi } from '../../api/auth-api';

const { getUrlWithRelayState } = WindowUtil;

export type CheckEmailRedirectProps = {
  name?: string;
};

export const CheckEmailRedirect = ({
  name = 'CHECK_EMAIL_REDIRECT',
}: CheckEmailRedirectProps = {}) => {
  const { setTitle } = useContext(PageContext);
  const location = useLocation();
  const { providedEmail } = useParams();
  const queryRaw = new URLSearchParams(location.search);
  const relayState = queryRaw.get('RelayState');
  const queryRelayParam = relayState && { RelayState: relayState };
  const responses = useApi(
    providedEmail
      ? AuthApi.readAuthForEmail({
          email: providedEmail,
          query: queryRelayParam || {},
        })
      : undefined
  );
  const { flowType, authRedirectUrl } = responses[0]?.data || {};
  const navigate = useNavigate();

  useEffect(() => {
    setTitle('Axiom Law - Checking Valid Email...');
  }, []);

  useEffect(() => {
    if (flowType === 'Verify') {
      void navigate(`../${providedEmail}/check-email`);
    } else if (flowType === 'Prompt') {
      const URL = getUrlWithRelayState(`../${providedEmail}/password`, {
        query: queryRaw,
      });
      void navigate(URL);
    } else if (authRedirectUrl) {
      const {
        origin,
        pathname,
        searchParams: authRedirectUrlSearchParams,
      } = new URL(authRedirectUrl);

      if (relayState) {
        authRedirectUrlSearchParams.append('RelayState', relayState);
      }

      window.location.assign(
        `${origin}${pathname}?${authRedirectUrlSearchParams.toString()}`
      );
    } else {
      void navigate(getUrlWithRelayState('/', { query: queryRaw }));
    }
  }, [providedEmail]);

  return <Loader type="logo" expand="fullscreen" name={name} />;
};
